import { PLATFORM_ROUTES } from '@platform/constants';

export const USER_DROPDOWN_OPTIONS = [
    {
        name: 'Account',
        href: PLATFORM_ROUTES.account_profile,
    },
    {
        name: 'Help',
        href: PLATFORM_ROUTES.dashboard_help_center,
    },
    {
        name: 'Report',
        href: 'mailto:help@buildmyedge.com',
    },
    {
        name: 'Billing',
        href: PLATFORM_ROUTES.account_billing,
    },
    {
        name: 'Manage Subscription',
        href: PLATFORM_ROUTES.account_manage_subscription,
    },
    {
        name: 'Purchase History',
        href: PLATFORM_ROUTES.dashboard_transactions,
    },
];
